import {
  LocalShippingOutlined,
  EventNoteOutlined,
  StoreOutlined,
  PeopleAltRounded,
  MapRounded,
  InboxRounded,
  Article,
  Assessment,
  Hub,
  Receipt,
  SportsMotorsports,
  Settings,
  Person,
  PostAdd,
  ReceiptLong,
  Group,
  Smartphone,
  RequestPage,
  Wallet,
  LocalShipping,
  LocationCity,
  Subscriptions,
  Discount,
  AddAlert,
  CloudUpload,
  Pending,
  NotificationAddOutlined,
  Warning,
  Calculate,
  MonetizationOn,
  SupportAgent,
  Warehouse,
  AirportShuttle,
  Report,
  ShoppingBagOutlined
} from "@mui/icons-material";
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
import RouteIcon from '@mui/icons-material/Route';
import ViewListIcon from "@mui/icons-material/ViewList";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import PendingActionsIcon from "@mui/icons-material/PendingActions";

export const TABS = [
  {
    icon: Report,
    title: "Statistics",
    href: "/admin",
  },
  {
    icon: Report,
    title: "Report",
    children: [{
      title: "Merchant Report",
      href: "/admin/merchant-report",
    }],
  },
  {
    icon: EventNoteOutlined,
    title: "Orders",
    children: [
      {
        title: "All",
        href: "/admin/orders/filter",
      },
      {
        title: "Mapit Ship",
        href: "/admin/orders/filter/mapit-ship?status=ORDER_PENDING"
      },
      {
        title: "Shipments",
        href: "/admin/orders/filter/shipments"
      },
      {
        href: "/admin/aramex-satchels?status=ORDER_ASSIGNED_TO_SHIPPING_COMPANY",
        title: "Aramex Satchels",
      }
    ]
  },
  {
    href: "/admin/tasks_filter",
    icon: EventNoteOutlined,
    title: "Tasks",
  },
  {
    href: "/admin/connection",
    icon: Hub,
    title: "Private connections",
  },
  {
    icon: Receipt,
    title: "Mapit Ship (COD)",
    children: [
      {
        title: "Withdrawal Requests",
        href: "/admin/mapit-ship-cod/withdrawal-requests",
      },
      {
        title: "COD Transactions",
        href: "/admin/mapit-ship-cod/cod-transactions",
      },
      {
        title: "COD Invoices",
        href: "/admin/mapit-ship-cod/details",
      },
    ],
  },
  {
    title: "Users",
    icon: Group,
    children: [
     
      {
        href: "/admin/inactive-merchants",
        icon: DoNotDisturbOnIcon,
        title: "inactive merchant",
      },
      {
        href: "/admin/merchants",
        icon: StoreOutlined,
        title: "Merchants",
      },
      {
        href: "/admin/users",
        icon: Group,
        title: "Accounts",
      },
      {
        href: "/admin/drivers",
        icon: LocalShippingOutlined,
        title: "Drivers",
      },
      {
        href: "/admin/admins",
        icon: PeopleAltRounded,
        title: "Admins",
      },
        {
        href: "/admin/classification",
        icon: FilterAltIcon,
        title: "Classification",
      },
       {
        href: "/admin/approvel",
        icon: PendingActionsIcon,
        title: "Pending Merchant Approval",
      },
    ],
  },
  {
    title: "Financials",
    icon: MonetizationOn,
    children: [
      {
        href: "/admin/mapit-ship-financial-report",
        icon: Receipt,
        title: "Financial Report",
      },
      {
        href: "/admin/wallet-transactions",
        icon: Wallet,
        title: "Wallet Transactions",
      },
      {
        href: "/admin/payment-gateway-transactions",
        icon: ReceiptLong,
        title: "paymentGatewayTransactions.title",
      },
      {
        href: "/admin/oto-transactions-discrepancies",
        icon: ReceiptLong,
        title: "OTO Transactions Discrepancies",
      },
    ],
  },
  {
    title: "Mapit Plans",
    icon: PostAdd,
    children: [
      {
        href: "/admin/plans",
        icon: PostAdd,
        title: "Plans",
      },
      {
        href: "/admin/merchants-subscriptions-log",
        icon: Subscriptions,
        title: "Subscriptions Log",
      },
      {
        href: "/admin/coupons",
        icon: Discount,
        title: "Coupons",
      },
    ],
  },
  {
    title: "Places",
    icon: LocationCity,
    children: [
      {
        href: "/admin/zones",
        icon: MapRounded,
        title: "Zones",
      },
      {
        href: "/admin/warehouses",
        icon: Warehouse,
        title: "Warehouses",
      },
    ],
  },
  {
    title: "Customers Support",
    icon: SupportAgent,
    children: [
      {
        href: "/admin/contact-us",
        icon: InboxRounded,
        title: "Contact Us Messages",
      },
      {
        href: "/admin/free-demo-requests",
        icon: RequestPage,
        title: "Free Demo Requests",
      },
    ],
  },
  {
    title: "Notifications",
    icon: AddAlert,
    children: [
      {
        title: "Alerts",
        href: "/admin/alerts",
        icon: Warning,
      },
      {
        title: "Notifications",
        href: "/admin/notifications",
        icon: NotificationAddOutlined,
      },
    ],
  },
  {
    href: "/admin/pending-canceled-shipments",
    icon: Pending,
    title: "Pending Canceled Shipments",
  },
  {
    href: "/admin/blog",
    icon: Article,
    title: "Blog",
  },
  {
    href: "/admin/account",
    icon: Person,
    title: "Account",
  },
  {
    title: "App Versions",
    href: "/admin/app-versions",
    icon: Smartphone,
  },
  {
    title: "Shipping Partners",
    href: "/admin/shipping-partners",
    icon: Hub,
  },
  {
    title: "Upload financial transactions",
    href: "/admin/upload-transactions",
    icon: CloudUpload,
  },
  {
    title: "Price Calculator",
    href: "/admin/price-calculator",
    icon: Calculate,
  },
  {
    title: "Delivery Options",
    icon: AirportShuttle,
    children: [
      {
        href: "/admin/delivery-options/general",
        title: "General",
      },
      {
        href: "/admin/delivery-options/merchant",
        title: "Merchant",
      },
      {
        href: "/admin/delivery-options/pricing-category",
        title: "Price Categories",
      },
    ],
  },
  {
    title: "Cities",
    icon: LocationCity,
    children: [
      {
        title: "Management",
        children: [
          {
            title: "Mapitship",
            href: "/admin/managment-cities/mapit-ship",
          },
          {
            title: "Aramex",
            href: "/admin/managment-cities/aramex",
          },
          {
            title: "OTO",
            href: "/admin/managment-cities/oto",
          },
          {
            title: "SMSA",
            href: "/admin/managment-cities/smsa",
          },
          {
            title: "RedBox",
            href: "/admin/managment-cities/redbox",
          },
        ],
      },
      {
        title: "Merge",
        children: [
          {
            title: "Aramex",
            href: "/admin/merge-cities/aramex",
          },

          {
            title: "Zid",
            href: "/admin/merge-cities/zid",
          },
          {
            title: "Salla",
            href: "/admin/merge-cities/salla",
          },
          {
            title: "OTO",
            href: "/admin/merge-cities/oto",
          },
          {
            title: "SMSA",
            href: "/admin/merge-cities/smsa",
          },
          {
            title: "RedBox",
            href: "/admin/merge-cities/redbox",
          },
        ],
      },
    ],
  },
   {
    title: "Here Logs",
    href: "/admin/here-logs",
    icon: RouteIcon,
  },
  {
    icon: Settings,
    title: "Settings",
    children: [
      {
        title: "General",
        href: "/admin/settings",
      },
      // {
      //   title: "Whatsapp Msgs",
      //   href: "/admin/settings/whatsapp",
      // },
      {
        title: "Language",
        href: "/admin/settings/language",
      },
      {
        title: "Tasks & SMS Default Pricing",
        href: "/admin/settings/price",
      },
      {
        title: "AI Assistant",
        href: "/admin/settings/ai-support",
        // Shown to AI developers only (AdminDrawer)
        requiresAiDeveloper: true,
      },
    ],
  },
];
